module.exports = __webpack_public_path__ + "static/media/FY.8ca6e309.png";